import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '../../../../../node_modules/@angular/router';
import { Subscription } from 'rxjs';

/**
 * Member eligibility component
 */
@Component({
	selector: 'app-member-eligibility',
	templateUrl: './member-eligibility.component.html',
	styleUrls: ['./member-eligibility.component.scss'],
})
export class MemberEligibilityComponent implements OnDestroy {
	/** Referral Member eligibility message string */
	message: string;
	/** Data carrier subscription */
	subscription: Subscription;

	/**
	 * Member eligibility constructor
	 * @param activatedRoute Contains the information about route associated
	 */
	constructor(private activatedRoute: ActivatedRoute) {
		this.subscription = this.activatedRoute.queryParams.subscribe(queryParams => {
			try {
				if (queryParams && queryParams.data) {
					this.message = JSON.parse(atob(queryParams.data));
				}
			} catch (Exception) {}
		});
	}

	/**
	 * Destroys the component
	 */
	ngOnDestroy() {
		this.subscription.unsubscribe();
	}
}
